import React from 'react';
import { useNavigate } from 'react-router-dom';
import Row from '../../../Common/Row';
import Col from '../../../Common/Col';
import Input from '../../../Common/HtmlTags/Input';
import Button from '../../../Common/HtmlTags/Button';
import LoadingIndicator from '../../../store/LoadingIndicator';
import { GoBack } from '../../../../containers/goBack/inedx';
import AdvancedUpload from '../../../store/AdanceFileUpload';
import AdvancedUploadHelper from '../../../store/AdanceFileUpload/updateFileUpload';
import { withRouter } from '../../../../withRouter';
import { connect } from 'react-redux';
import actions from '../../../../actions';
import { API_URL } from '../../../../constants';

const EditTeamMemberForm = (props) => {
  const {
    teamMember,
    editFormErrors,
    teamMemberEditChange,
    updateTeamMember,
    deleteTeamMember,
    isLoading,
    isLightMode,
  } = props;

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    updateTeamMember(navigate);
  };

  const existingImageUrls = teamMember.imageUrl
    ? [`${API_URL}${teamMember.imageUrl}`]
    : [];

  return (
    <div className='add-event d-flex flex-column mb-custom-5em'>
      {isLoading && <LoadingIndicator isLightMode={isLightMode} />}
      <div
        style={{
          marginBottom: '-1em',
          justifyContent: 'space-between',
          padding: '0em 1em',
        }}
        className='d-flex team-members-header'
      >
        <h2 className={`${isLightMode ? 'p-black' : 'p-white'} font-size-25`}>
          Team Member Details
        </h2>
        <GoBack navigate={navigate} />
      </div>

      <form noValidate>
        <Row>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12' lg='6'>
            <Input
              type='text'
              error={editFormErrors.name}
              label='Name'
              name='name'
              placeholder='Enter team member name'
              value={teamMember.name || ''}
              onInputChange={teamMemberEditChange}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12' lg='6'>
            <Input
              type='text'
              error={editFormErrors.role}
              label='Role'
              name='role'
              placeholder='Enter role'
              value={teamMember.role || ''}
              onInputChange={teamMemberEditChange}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12'>
            <Input
              type='textarea'
              error={editFormErrors.bio}
              label='Bio'
              name='bio'
              rows={5}
              placeholder='Enter a short bio'
              value={teamMember.bio || ''}
              onInputChange={teamMemberEditChange}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12'>
            <h5>Replace Photo</h5>
            <AdvancedUpload
              error={editFormErrors.image}
              onFilesChange={(files) => teamMemberEditChange('image', files)}
              imageLimit={10 * 1024 * 1024}
              videoLimit={0}
              limit={1}
              vLimit={0}
            />
            {existingImageUrls.length > 0 && (
              <>
                <h5 style={{ paddingTop: '1em' }}>Current Photo</h5>
                <AdvancedUploadHelper initialUrls={existingImageUrls} />
              </>
            )}
          </Col>
        </Row>
      </form>
      <Row>
        <div className='edit-event-actions'>
          <Button onClick={handleSubmit} style={{ padding: '10px 20px' }} text='Save Team Member' />
          <Button
            onClick={() => deleteTeamMember(teamMember._id, navigate)}
            style={{ padding: '10px 20px' }}
            text='Delete Team Member'
          />
        </div>
      </Row>
    </div>
  );
};

class EditTeamMember extends React.PureComponent {
  componentDidMount() {
    this.props.resetTeamMember();
    const teamMemberId = this.props.match.params.id;
    this.props.fetchTeamMember(teamMemberId);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.props.resetTeamMember();
      const teamMemberId = this.props.match.params.id;
      this.props.fetchTeamMember(teamMemberId);
    }
  }

  render() {
    return <EditTeamMemberForm {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  teamMember: state.teamMembers.teamMember,
  editFormErrors: state.teamMembers.editFormErrors,
  isLoading: state.teamMembers.isLoading,
  isLightMode: state.dashboard.isLightMode,
});

export default connect(mapStateToProps, actions)(withRouter(EditTeamMember));
